import styled from 'styled-components'

export const WeekPickerPanelWrapper = styled.div`
    th[aria-label="empty cell"],
    .ant-picker-cell-week{
        display: none;
    }
`
